
const whoConfig = {
    strings: ['Software Engineer', 'Data Engineer', 'Backend Developer'],
    autoStart: true,
    loop: true,
}


export default whoConfig